<template>
  <picture v-if="role?.id && role?.id != 'empty'" class="role">
    <img :src="rolePath" />
  </picture>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getRoleImage } from '@/services/assets';
import type { Player, Role } from '@/types';

const props = defineProps<{
  role: Role;
  player?: Player | undefined;
}>();

const role = computed(() => props.role);

const rolePath = computed(() => getRoleImage(props.role, props.player?.alignment));
</script>

<style scoped lang="scss">
.role {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  z-index: 0;
  margin-top: 0.3em;
}

.role img,
.role svg {
  max-width: 100%;
  max-height: 100%;
}

.transparent img {
  opacity: 0.4;
}
</style>
